<template>
  <layout :show-profile="true">
    <div class="mt-12 sm:mt-0 px-4 sm:px-0 py-5">
      <div class="min-w-0 flex-1 h-full max-w-sm mx-auto lg:order-last px-3 select-none">
        <img src="/img/participate.png" class="w-3/5 sm:w-4/5 mx-auto my-12" />
      </div>

      <fieldset class="mt-12 max-w-sm mx-auto select-none">
        <div class="space-y-4">

          <!-- dictionary: start -->
          <Link v-if="$page.props.auth.user.can.use.dictionary" :href="route('markencode.dictionary.index')"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white">
          <span class="text-sm font-medium text-gray-900">Werteräume</span>
          </Link>
          <!-- dictionary: end -->



          <!-- productivity: start -->
          <Link v-if="$page.props.auth.user.can.use.productivity" :href="route('control-panel.productivity.create')"
            method="post"
            as="button"
            class="relative block w-full text-left cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white">
          <span class="text-sm font-medium text-gray-900">Productivity</span>
          
          </Link>
          <!-- productivity: end -->





          <!-- Workshop / Survey: start -->
          <Link v-if="$page.props.auth.user.can.use.workshop"
            :href="route('control-panel.workshops.index')"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white">
          <span class="text-sm font-medium text-gray-900">Workshops &amp; Umfragen</span>
          </Link>
          <!-- Workshop / Survey: end -->


          <!-- Orders: start -->
          <Link
            v-if="$page.props.auth.user.can.use.workshop"
            :href="route('control-panel.orders.index')"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white">
          <span class="text-sm font-medium text-gray-900">Bestellungen</span>
          </Link>
          <!-- Orders: end -->


          <!-- Copy Quick Check: start -->
          <Link
            v-if="$page.props.auth.user.can.use.copy_quick_check_full || $page.props.auth.user.can.use.copy_quick_check_limited"
            :href="route('copy-quick-check.index')"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white">
          <span class="text-sm font-medium text-gray-900">Copy Quick Check</span>
          </Link>
          <!-- Copy Quick Check: end -->

        </div>
      </fieldset>
    </div>


  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';

export default {
  components: {
    Layout,
    HorizontalDivider,
  },

  props: ['translations'],

};
</script>